module.exports = __webpack_public_path__ + "images/emoji/speedboat.319f12b7bec1d99bb31e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/speedboat.png
// module id = XH8n
// module chunks = 13